var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g2, _path21, _path22, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceFeature6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 240,
    viewBox: "0 0 274 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.0859 214.753C88.697 214.753 86.7576 212.818 86.7576 210.434C86.7576 208.045 88.697 206.111 91.0859 206.111H116.616C119.01 206.111 120.944 208.045 120.944 210.434C120.944 212.818 119.01 214.753 116.616 214.753H91.0859ZM100.379 187.884C97.9848 187.884 96.0454 185.949 96.0454 183.561C96.0454 181.177 97.9848 179.237 100.379 179.237H125.909C128.298 179.237 130.237 181.177 130.237 183.561C130.237 185.949 128.298 187.884 125.909 187.884H100.379Z",
    fill: "#847784"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.343 30.9545C230.657 29.2677 230.657 26.5303 232.343 24.8434C234.035 23.1566 236.778 23.1566 238.47 24.8434L246.924 33.2828L261.889 13.3636C263.318 11.4646 266.02 11.0757 267.924 12.505C269.833 13.9293 270.217 16.6313 268.788 18.5303L250.439 42.9091C248.752 44.5959 246.01 44.5959 244.318 42.9091L232.343 30.9545ZM238.47 211.48C236.778 213.167 234.035 213.167 232.343 211.48C230.657 209.793 230.657 207.056 232.343 205.369L244.01 193.727L232.343 182.086C230.657 180.399 230.657 177.662 232.343 175.975C234.035 174.283 236.778 174.283 238.47 175.975L250.131 187.616L261.793 175.975C263.485 174.283 266.227 174.283 267.919 175.975C269.606 177.662 269.606 180.399 267.919 182.086L256.252 193.727L267.919 205.369C269.606 207.056 269.606 209.793 267.919 211.48C266.227 213.167 263.485 213.167 261.793 211.48L250.131 199.838L238.47 211.48ZM232.343 141.51C230.657 139.818 230.657 137.081 232.343 135.394C234.035 133.707 236.778 133.707 238.47 135.394L246.924 143.833L261.889 123.919C263.318 122.015 266.02 121.631 267.924 123.056C269.833 124.485 270.217 127.182 268.788 129.081L250.439 153.46C248.752 155.146 246.01 155.146 244.318 153.46L232.343 141.51ZM232.343 86.2323C230.657 84.5454 230.657 81.8081 232.343 80.1212C234.035 78.4343 236.778 78.4343 238.47 80.1212L246.924 88.5606L261.889 68.6414C263.318 66.7374 266.02 66.3535 267.924 67.7828C269.833 69.2071 270.217 71.904 268.788 73.8081L250.439 98.1818C248.752 99.8687 246.01 99.8687 244.318 98.1818L232.343 86.2323Z",
    fill: "#4187B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1465 83.6364C57.8233 83.6364 46.2122 95.2273 46.2122 109.525C46.2122 123.823 57.8233 135.419 72.1465 135.419C86.4748 135.419 98.0859 123.823 98.0859 109.525C98.0859 95.2273 86.4748 83.6364 72.1465 83.6364Z",
    fill: "#F0B16E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1465 135.419C43.0252 135.419 19.197 159.202 19.197 188.273V235.061H125.096V188.273C125.096 159.202 101.273 135.419 72.1465 135.419Z",
    fill: "#60B7FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.308 158.934L128.985 235.061H61.6869L88.0101 158.934H155.308Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.45 11.4697H205.546C208.798 11.4697 211.46 14.1263 211.46 17.3737V38.4293C211.46 41.6768 208.798 44.3333 205.546 44.3333H184.45C181.197 44.3333 178.535 41.6768 178.535 38.4293V17.3737C178.535 14.1263 181.197 11.4697 184.45 11.4697Z",
    fill: "#14B5A2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.45 66.7424H205.546C208.798 66.7424 211.46 69.399 211.46 72.6515V93.702C211.46 96.9495 208.798 99.6111 205.546 99.6111H184.45C181.197 99.6111 178.535 96.9546 178.535 93.702V72.6515C178.535 69.399 181.197 66.7424 184.45 66.7424Z",
    fill: "#14B5A2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.45 122.02H205.546C208.798 122.02 211.46 124.677 211.46 127.924V148.98C211.46 152.227 208.798 154.884 205.546 154.884H184.45C181.197 154.884 178.535 152.227 178.535 148.98V127.924C178.535 124.677 181.197 122.02 184.45 122.02Z",
    fill: "#14B5A2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.45 177.293H205.546C208.798 177.293 211.46 179.949 211.46 183.202V204.253C211.46 207.505 208.798 210.162 205.546 210.162H184.45C181.197 210.162 178.535 207.505 178.535 204.253V183.202C178.535 179.949 181.197 177.293 184.45 177.293Z",
    fill: "#E33F65"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1466",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 0,
    width: 100,
    height: 71
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7828 0H121.045V70.2929H22.7828V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1466)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1263 0.0808105C27.5505 0.0808105 23.803 6.09091 23.803 13.4394V38.6717C23.803 46.0152 27.5505 52.0253 32.1263 52.0253H57.0606C60.101 52.0253 62.7121 53.7929 64.8333 57.2727L72.1465 69.2778L79.4647 57.2727C81.5859 53.7929 84.197 52.0253 87.2323 52.0253H112.167C116.747 52.0253 120.495 46.0152 120.495 38.6717V13.4394C120.495 6.09091 116.747 0.0808105 112.167 0.0808105C77.6313 0.0808105 66.6667 0.0808105 32.1263 0.0808105Z",
    fill: "#FFBF31"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1465 83.6364C57.8233 83.6364 46.2122 95.2273 46.2122 109.525C46.2122 118.672 50.9596 126.707 58.1314 131.313C60.3536 131.929 62.692 132.263 65.1061 132.263C79.4293 132.263 91.0455 120.672 91.0455 106.374C91.0455 97.2273 86.293 89.1869 79.1212 84.5858C76.9041 83.9646 74.5657 83.6364 72.1465 83.6364Z",
    fill: "#FCD4A9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1465 135.419C43.0252 135.419 19.197 159.202 19.197 188.273V231.904H118.056V185.116C118.056 165.056 106.707 147.51 90.101 138.566C84.4899 136.53 78.4444 135.419 72.1465 135.419Z",
    fill: "#88C8FE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7778 231.904L88.0101 158.934H111.056C115.505 166.662 118.056 175.606 118.056 185.116V231.904H62.7778Z",
    fill: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.096 222.778V188.273C125.096 176.045 120.884 164.758 113.833 155.778H80.9647L54.6414 231.904H121.944L125.096 222.778Z",
    fill: "#60B7FE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7778 231.904L88.0101 158.934H147.177L121.944 231.904H62.7778Z",
    fill: "#E6E6E6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.45 11.4697H203.732C204.167 12.2929 204.419 13.2273 204.419 14.2172V35.2727C204.419 38.5202 201.753 41.1768 198.5 41.1768H179.222C178.783 40.3586 178.535 39.4192 178.535 38.4293V17.3737C178.535 14.1263 181.197 11.4697 184.45 11.4697Z",
    fill: "#19CFBA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.45 66.7424H203.732C204.167 67.5657 204.419 68.5051 204.419 69.495V90.5455C204.419 93.798 201.753 96.4546 198.5 96.4546H179.222C178.783 95.6313 178.535 94.697 178.535 93.702V72.6515C178.535 69.399 181.197 66.7424 184.45 66.7424Z",
    fill: "#19CFBA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.45 122.02H203.732C204.167 122.843 204.419 123.778 204.419 124.768V145.823C204.419 149.071 201.753 151.732 198.5 151.732H179.222C178.783 150.909 178.535 149.97 178.535 148.98V127.924C178.535 124.677 181.197 122.02 184.45 122.02Z",
    fill: "#19CFBA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.45 177.293H203.732C204.167 178.116 204.419 179.056 204.419 180.045V201.101C204.419 204.348 201.753 207.005 198.5 207.005H179.222C178.783 206.182 178.535 205.247 178.535 204.253V183.202C178.535 179.949 181.197 177.293 184.45 177.293Z",
    fill: "#FA6E85"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_1466",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 0,
    width: 93,
    height: 63
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7828 0H114.581V62.5354H22.7828V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_1466)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1263 0.0808105C27.5505 0.0808105 23.803 6.09091 23.803 13.4394V38.6717C23.803 42.7525 24.9596 46.4192 26.7677 48.8737H50.0202C52.3737 48.8737 54.4697 49.9293 56.2828 52.0253H57.0606C60.101 52.0253 62.7121 53.7929 64.8333 57.2727L67.6667 61.9242L72.4192 54.1162C74.5404 50.6364 77.1566 48.8737 80.1919 48.8737H105.126C109.707 48.8737 113.455 42.8636 113.455 35.5152V10.2828C113.455 6.20707 112.298 2.53536 110.485 0.0808105H32.1263Z",
    fill: "#FFE177"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6313 29.5C53.9394 27.8131 53.9394 25.0758 55.6313 23.3889C57.3232 21.702 60.0656 21.702 61.7525 23.3889L69 30.6212L82.1515 13.1162C83.5808 11.2172 86.2879 10.8283 88.1919 12.2576C90.096 13.6818 90.4848 16.3788 89.0555 18.2828L72.5202 40.2475C70.8283 41.9343 68.0858 41.9343 66.3939 40.2475L55.6313 29.5Z",
    fill: "#4187B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_1466",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 230,
    width: 274,
    height: 10
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 230.616H273.318V239.399H0V230.616Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_1466)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.955 230.737C271.343 230.737 273.283 232.672 273.283 235.061C273.283 237.444 271.343 239.379 268.955 239.379H4.29795C1.90906 239.379 -0.0303345 237.444 -0.0303345 235.061C-0.0303345 232.672 1.90906 230.737 4.29795 230.737H268.955Z",
    fill: "#C89D8D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceFeature6);
export default __webpack_public_path__ + "static/media/serviceFeature6.4934fcf3f8129468c590c674d26326ed.svg";
export { ForwardRef as ReactComponent };